import { Paper } from "@material-ui/core";
import React from "react";
import { ArrivedPopupProvider } from "resources/orders/forms/ArrivedPopupContextManager";

import { useMutateForm } from "../../../../api/useMutateForm";
import { SimpleFormAdv } from "../../../../components/forms/SimpleFormAdv";
import { OrderService } from "../../../../entities/OrderService";
import { ActionsWithBackButton } from "./Actions";
import { FormCustomerTransporter, FormManager } from "./forms";

const createExtendOrderPayload = (service) => (data, context) => {
	if (
		service !== null &&
		service !== undefined &&
		service === OrderService.coldStorage &&
		["updateMany", "updateManyArray", "updateManyPartialArray"].includes(context.type)
	) {
		return { ...data, service };
	}
	return data;
};

export const MultipleOrderEditBase = (Form, name) => (props) => {
	const extendOrderPayload = createExtendOrderPayload(props?.record?.service);

	// eslint-disable-next-line react-hooks/rules-of-hooks
	const [mutateForm, state] = useMutateForm(
		"updateManyArray",
		props.resource,
		props.basePath,
		props.selectedIds,
		{},
		undefined, // handleCustomRedirect
		extendOrderPayload // extendPayload callback
	);
	const toolbarCompProps = {
		useSaveButtonEx: true,
		saveButtonExProps: {
			multiRecordData: props.initRecordData,
			onSave: mutateForm,
		},
	};

	return (
		<React.Fragment>
			<ArrivedPopupProvider>
				<ActionsWithBackButton basePath={props.basePath} />
				<Paper>
					<SimpleFormAdv
						{...props}
						children={<Form initRecordData={props.initRecordData} />}
						toolbarCompProps={toolbarCompProps}
					/>
				</Paper>
			</ArrivedPopupProvider>
		</React.Fragment>
	);
};

export const MultipleOrderEditByOSFC = MultipleOrderEditBase(FormManager, "OSFC");
export const MultipleOrderEditByCustomer = MultipleOrderEditBase(
	FormCustomerTransporter,
	"Customer"
);
